import  Layout          from    "../../internal/Layout.vue";
import  UserContext     from    "./UserContext.vue";

const   ContextRoutes   = {
    component           : Layout,
    children            : [
        {
            name        : 'user-context',
            path        : '/user-context',
            component   : UserContext,
            meta        : {}
        }
    ]
};

export default          ContextRoutes;